import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from 'fuse-ui/components/Typography';
import DomainList from '../sender-verification/domains-list';
import opacity from '../common/theme/colors/opacity';

const styles = theme => ( {
    senderInfo: {
        marginBottom: `${theme.spacing.unit * 2}px`,
    }
} );

const SenderDetailsTabDomains = ( { classes, domainsData, onEdit, senderName } ) => {
    return (
        <>
            <div data-automation-id="sender-detail-domain-list" className={classes.senderInfo}>
                <Typography data-automation-id="dd-senders-heading-domain" variant="subtitle1">Sending as following domains</Typography>
                <Typography style={{ color: opacity.black60 }} variant="body1">
                    {senderName} is sending messages on behalf of the following domains.
                The status of a sender determines how EFD will categorize the data for processing and reporting.
                </Typography>
            </div>
            <DomainList domainsData={domainsData} onEdit={onEdit}/>
        </>
    );
};

SenderDetailsTabDomains.propTypes = {
    classes: PropTypes.object.isRequired,
    domainsData: PropTypes.arrayOf( PropTypes.object ),
    onEdit: PropTypes.func.isRequired,
    senderName: PropTypes.string.isRequired,
};

export default withStyles( styles )( SenderDetailsTabDomains );
